<template>
  <DashboardLayout>

    <div class="d-flex align-items-center gap-2 mb-4 page-identifier">
      <p class="mb-0 main-identifier fw-semibold">Appraisal</p>
      <span class="material-symbols-outlined">keyboard_arrow_right</span>
      <p class="mb-0 sub-identifier">Create Memo</p>
    </div>

    <div class="d-flex justify-content-center mb-5">

      <div class="form-outer">
        <form @submit.prevent="step === totalSteps ? handleSubmit() : handleNext()">
          <div class="crud-form position-relative">

            <div class="form-inner mb-2">
              <div class="form-header d-flex justify-content-between align-items-center">
                <!-- <h1 class="mb-0">Initiate Appraisal (Step {{ step }} of {{ totalSteps }})</h1> -->
                <h1 class="mb-0">Create Memo</h1>
                <button
                  v-if="isLinkedPaymentVoucher"
                  type="button"
                  class="btn btn-sm pv-preview-btn"
                  @click="openPvPreview"
                >
                  View Payment Voucher
                </button>
              </div>

              <div class="header-box d-flex justify-content-between align-items-center mb-3">
                <div class="progress-bar" :style="{
                  '--progress-width': progressWidth,
                  '--step-count': totalSteps
                }">
                  <!-- Row 1: Step Icons -->
                  <div class="step-icon" v-for="(s, i) in totalSteps" :key="'icon-' + i">
                    <div :class="['step', { active: step === i + 1, completed: step > i + 1 }]">
                      {{ step > i + 1 ? '✓' : i + 1 }}
                    </div>
                  </div>

                  <!-- Row 2: Progress Line -->
                  <div class="progress-line" :style="{ '--progress-width': progressWidth }" />

                  <!-- Row 3: Step Labels -->
                  <div class="step-label text-wrap" v-for="(s, i) in steps" :key="'label-' + i"
                    :class="{ active: step === i + 1 }">
                    {{ s.label }}
                  </div>
                </div>
              </div>

              <div v-if="step === 1">

                <div class="form-body">
                  <!-- <h2 class="field-head">A. General Information</h2> -->
                  <div class="row mb-3">
                    <div class="col-md-12 row form-group position-relative floating-label-group">
                      <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year"
                          class="form-label">File Title</label></div>
                      <div class="col-md-9 input-right">
                        <input id="fileName" type="text" class="form-control" v-model="form.fileTitle"
                          placeholder="Enter file title" required />
                      </div>
                    </div>

                    <div class="col-md-12 row form-group position-relative floating-label-group">
                      <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year"
                          class="form-label">File Number</label></div>
                      <div class="col-md-9 input-right">
                        <input id="fileNumber" type="text" class="form-control" v-model="form.fileNumber"
                          placeholder="Enter file number" required />
                      </div>
                    </div>

                    <div class="col-md-12 row form-group position-relative floating-label-group">
                      <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year"
                          class="form-label">Sector</label></div>
                      <div class="col-md-9 input-right">
                        <select class="form-select" v-model="sector" @change="onSectorChange" :disabled="isLinkedMdaLocked"
                          :required="!isLinkedMdaLocked">
                          <option value="" disabled>- Select Sector -</option>
                          <option v-for="sector in sectors" :key="sector.id" :value="sector.id">{{ sector.code }} ({{
                            sector.name }})</option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-12 row form-group position-relative floating-label-group">
                      <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year"
                          class="form-label">Originating MDA</label></div>
                      <div class="col-md-9 input-right">
                        <select class="form-select" v-model="mda" @change="onMdaChange" :disabled="isLinkedMdaLocked"
                          :required="!isLinkedMdaLocked">
                          <option value="" disabled>- Select MDA -</option>
                          <option v-for="mda in mdas" :key="mda.id" :value="mda.id">{{ mda.name }}</option>
                        </select>
                        <input type="hidden" v-model="form.originatingMda">
                      </div>
                    </div>

                    <div class="col-md-12 row form-group position-relative floating-label-group">
                      <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year"
                          class="form-label">Amount Approved (₦)</label></div>
                      <div class="col-md-9 input-right">

                        <input
                          id="amountApproved"
                          type="text"
                          class="form-control"
                          :value="formatCurrency(form.amountApproved)"
                          inputmode="numeric"
                          @input="onAmountApprovedInput"
                          :readonly="isLinkedPaymentVoucher"
                          placeholder="0.00"
                          required
                        />
                        <!-- <input id="amountApproved" type="text" class="form-control"
                          :value="formatNumber(form.amountApproved)" inputmode="numeric" pattern="[0-9,]*"
                          @keypress="onlyDigitsAndComma" @input="onAmountApprovedInput" placeholder="" required /> -->
                      </div>
                    </div>

                    <!-- <div class="col-md-12 row form-group position-relative floating-label-group">
                      <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year"
                          class="form-label">Purpose of Request</label></div>
                      <div class="col-md-9 input-right">
                        <div class="col-md-12 input-right">
                          <textarea class="form-control" id="description" v-model="form.purposeOfRequest" placeholder=""
                            rows="3" required></textarea>
                        </div>
                      </div>
                    </div> -->

                    <!-- <input type="hidden" v-model="form.created_by" /> -->

                  </div>
                </div>
              </div>


              <div class="mt-4">
                <div v-if="step === totalSteps" class="d-flex justify-content-center gap-3">

                  <button type="submit" class="btn btn-primary submit-btn" :disabled="loading || !form.fileTitle || !form.fileNumber || !sector || !mda || form.amountApproved === 0">

                    <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status"
                      aria-hidden="true"></span>

                    {{ (loading ? 'Submitting...' : 'Submit') }}
                  </button>
                </div>
              </div>
            </div>

          </div>
        </form>
      </div>
    </div>

      <div v-if="showPvPreview" class="pv-preview-overlay" @click="closePvPreview">
        <div class="pv-preview-modal" @click.stop>
          <div class="pv-preview-header">
            <h5 class="mb-0">Payment Voucher Details</h5>
            <button type="button" class="btn-close" aria-label="Close" @click="closePvPreview"></button>
          </div>

          <div class="pv-preview-body">
            <div class="preview-grid mb-3">
              <div class="preview-item">
                <small>PV Number</small>
                <p class="mb-0">{{ linkedPvPreview.pvNumber || 'N/A' }}</p>
              </div>
              <div class="preview-item">
                <small>Payee</small>
                <p class="mb-0">{{ linkedPvPreview.payee || 'N/A' }}</p>
              </div>
              <div class="preview-item">
                <small>MDA</small>
                <p class="mb-0">{{ linkedPvPreview.mdaName || 'N/A' }}</p>
              </div>
              <div class="preview-item">
                <small>Bank</small>
                <p class="mb-0">{{ linkedPvPreview.bankName || 'N/A' }}</p>
              </div>
              <div class="preview-item">
                <small>Payment Type</small>
                <p class="mb-0">{{ linkedPvPreview.paymentType || 'N/A' }}</p>
              </div>
              <div class="preview-item">
                <small>Payment Date</small>
                <p class="mb-0">{{ formatDisplayDate(linkedPvPreview.paymentDate) }}</p>
              </div>
              <div class="preview-item">
                <small>Gross Amount</small>
                <p class="mb-0">{{ formatCurrency(linkedPvPreview.grossAmount) || 'N/A' }}</p>
              </div>
              <div class="preview-item">
                <small>Net Amount</small>
                <p class="mb-0">{{ formatCurrency(linkedPvPreview.netAmount) || 'N/A' }}</p>
              </div>
              <div class="preview-item">
                <small>Warrant Number</small>
                <p class="mb-0">{{ linkedPvPreview.warrantNumber || 'N/A' }}</p>
              </div>
              <div class="preview-item preview-item-wide">
                <small>Particulars</small>
                <p class="mb-0">{{ linkedPvPreview.particulars || 'N/A' }}</p>
              </div>
            </div>

            <div class="table-responsive">
              <table class="table table-bordered text-center align-middle">
                <thead class="table-header">
                  <tr>
                    <th>Deduction Type</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!Array.isArray(linkedPvPreview.deductions) || linkedPvPreview.deductions.length === 0">
                    <td colspan="2" class="text-muted">No deductions available</td>
                  </tr>
                  <tr v-for="(item, index) in linkedPvPreview.deductions" :key="`pv-preview-ded-${index}`">
                    <td>{{ item.dedTypeName || item.name || 'N/A' }}</td>
                    <td>{{ formatCurrency(item.amount) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

  </DashboardLayout>
</template>

<script setup>
import { ref, reactive, onMounted, computed } from 'vue'
import axios from 'axios'
import DashboardLayout from '../layout/DashboardLayout.vue'
import Cookies from 'js-cookie';
import Swal from 'sweetalert2';
import { useRoute, useRouter } from 'vue-router';
// import { useRouter } from 'vue-router';

const router = useRouter();
const mdas = ref([])

const sectors = ref([])

const sector = ref('')
const mda = ref('')
const route = useRoute()
const payVoucherIdFromQuery = computed(() => {
  if (route.query.paymentVoucherId) return String(route.query.paymentVoucherId)
  return ''
})
const isLinkedPaymentVoucher = computed(() => Boolean(payVoucherIdFromQuery.value))
const isLinkedMdaLocked = ref(false)
const showPvPreview = ref(false)
const linkedPvPreview = ref({})

const root_api_url = process.env.VUE_APP_API_ROOT_URL
const totalSteps = 1
const step = ref(1)
const loading = ref(false)

// Progress bar and step
const steps = [
  { label: 'General Information' },
]

const progressWidth = computed(() => {
  const total = steps.length;
  const percentPerStep = 100 / total; // each step adds this much
  return (step.value * percentPerStep) + '%';
});

// Reactive form data
const form = reactive({
  originatingMda: '',
  mdaId: '',
  orgCode: '',
  amountApproved: '',
  fileTitle: '',
  fileNumber: '',
  // purposeOfRequest: '',
  ticketId: '',
  isEditableInd: '',
  groupTypeId: '',
  memoRejectedInd: '',
  memoReturnedInd: '',
  grpHeadGrpMemId: '',
  grpHeadGrpMemRemarks: '',
  grpHeadGrpMemRemarksDate: '',
  id: '',
  version: '',
  createdDate: '',
  lastModifiedDate: '',
  createdBy: '',
  lastModifiedBy: '',
  userId: '',
  fileTrackerNumber: '',
})

const initialForm = JSON.parse(JSON.stringify(form));

function resetAll() {
  // back to step 1mdaLineItemBudgetId
  step.value = 1;

  // clear selects
  sector.value = '';
  mda.value = '';
  isLinkedMdaLocked.value = false;
  mdas.value = [];

  // restore form fields
  Object.assign(form, JSON.parse(JSON.stringify(initialForm)));
}

// const mda_datas = ref('')

const fetchSectors = async () => {
  const token = Cookies.get('auth_token');
  try {
    const response = await axios.get(`${root_api_url}/eli/sector`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    sectors.value = response.data.map(sector => ({
      id: sector.id,
      code: sector.sectorCode,
      name: sector.description,
    }))

  } catch (error) {
    console.error('Failed to fetch sectors:', error)
  }
}

const fetchMDAs = async (sector_id) => {
  const token = Cookies.get('auth_token');
  try {
    const response = await axios.get(`${root_api_url}/eli/mda/all/${sector_id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    mdas.value = response.data.map(mda => ({
      id: mda.id,
      name: mda.name,
    }))

  } catch (error) {
    console.error('Failed to fetch roles:', error)
  }
}

const fetchLinkedPaymentVoucher = async () => {
  if (!payVoucherIdFromQuery.value) return

  const token = Cookies.get('auth_token')

  try {
    const { data } = await axios.get(`${root_api_url}/payment/voucher/${payVoucherIdFromQuery.value}`, {
      headers: { Authorization: `Bearer ${token}` }
    })

    linkedPvPreview.value = data || {}
    isLinkedMdaLocked.value = Boolean(data?.mdaId && data?.mdaName)

    form.amountApproved = Number(data?.grossAmount || 0)
    mda.value = data?.mdaId || ''
    form.originatingMda = data?.mdaName || ''

    if (mda.value && form.originatingMda) {
      const exists = mdas.value.some(item => String(item.id) === String(mda.value))
      if (!exists) {
        mdas.value = [{ id: mda.value, name: form.originatingMda }, ...mdas.value]
      }
    }
  } catch (error) {
    console.error('Failed to fetch linked payment voucher:', error)
  }
}

const openPvPreview = () => {
  showPvPreview.value = true
}

const closePvPreview = () => {
  showPvPreview.value = false
}

const checkExistingMemoForPaymentVoucher = async (tokenFromCaller) => {
  if (!payVoucherIdFromQuery.value) return false

  const token = tokenFromCaller || Cookies.get('auth_token')

  try {
    const { data } = await axios.get(`${root_api_url}/appraisal/memo/pv/${payVoucherIdFromQuery.value}`, {
      headers: { Authorization: `Bearer ${token}` }
    })

    return Boolean(data?.id)
  } catch (error) {
    if (error?.response?.status === 404) {
      return false
    }

    throw error
  }
}

const handleSubmit = async () => {
  const token = Cookies.get('auth_token');

  const iconHtmlSuccess = `<span class="iconify" data-icon="ci:circle-check" style="font-size: 100px; color: green;"></span>`
  const iconHtmlError = `<span class="iconify" data-icon="material-symbols:cancel-outline-rounded" style="font-size: 100px; color: red;"></span>`

  if (payVoucherIdFromQuery.value) {
    try {
      const memoExists = await checkExistingMemoForPaymentVoucher(token)

      if (memoExists) {
        await Swal.fire({
          html: `${iconHtmlError}
        <h1 style="font-weight:600;">Error</h1>
        <p>Memo already exists for this payment voucher.</p>`,
          showConfirmButton: true,
          showCloseButton: true,
          icon: undefined,
        })

        router.push({
          name: 'ViewLinkPaymentVoucher',
          params: { id: String(payVoucherIdFromQuery.value) }
        })
        return
      }
    } catch (error) {
      await Swal.fire({
        html: `${iconHtmlError}
        <h1 style="font-weight:600;">Error</h1>
        <p>${error?.response?.data?.errorMessage || error?.response?.data?.error || error?.response?.data?.message || 'Unable to validate payment voucher memo state.'}</p>`,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      })
      return
    }
  }

  const memoData = {
    fileTitle: form.fileTitle,
    fileNumber: form.fileNumber,
    mdaId: mda.value,
    originatingMda: form.originatingMda,
    amountApproved: form.amountApproved,
    // purposeOfRequest: form.purposeOfRequest,
    groupTypeId: form.groupTypeId,
    ticketId: form.ticketId,
    grpHeadGrpMemId: form.grpHeadGrpMemId,
    fileTrackerNumber: form.fileTrackerNumber,
    ...(payVoucherIdFromQuery.value ? { payVoucherId: payVoucherIdFromQuery.value } : {}),
  };

  loading.value = true;

  try {
    const { data: createdMemo } = await axios.post(`${root_api_url}/appraisal/memo`, memoData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    // console.log('Memo created successfully:', data);
    await Swal.fire({
      html: `${iconHtmlSuccess} <h1 style="font-weight:600;">Success</h1> <p>Memo Created Successfully</p> `,
      showConfirmButton: true,
      showCloseButton: true,
      icon: undefined,
    })

    resetAll()

    if (payVoucherIdFromQuery.value) {
      const createdMemoId = createdMemo?.id || createdMemo?.memoId
      if (createdMemoId) {
        router.replace({ name: 'ViewMemo', params: { id: String(createdMemoId) } })
      } else {
        router.replace({ name: 'CreateMemo' })
      }
    }

  } catch (error) {
    // Swal.fire({
    //   html: `${iconHtmlError}
    //   <h1 style="font-weight:600;">Error</h1>
    //   <p>Failed to create memo</p>`,
    //   showConfirmButton: true,
    //   showCloseButton: true,
    //   icon: undefined,
    // });

    if (error.response) {
        Swal.fire({
          html: `${iconHtmlError}
        <h1 style="font-weight:600;">Error</h1>
        <p>${error?.response?.data?.errorMessage || error?.response?.data?.error || error?.response?.data?.message || 'Unexpected error occurred, kindly contact administrator.'}</p>`,
          showConfirmButton: true,
          showCloseButton: true,
          icon: undefined,
        });
      } else {
        Swal.fire({
          html: `${iconHtmlError}
        <h1 style="font-weight:600;">Error</h1>
        <p>Unexpected error occurred, kindly contact administrator.</p>`,
          showConfirmButton: true,
          showCloseButton: true,
          icon: undefined,
        });
      }
  } finally {
    loading.value = false; // Stop loading
  }
}

onMounted(() => {
  // fetchApprovalAuthority()
  // fetchMDAs()
  fetchSectors(),
    fetchLinkedPaymentVoucher(),
    document.title = "Create Memo"
})

function onSectorChange() {
  if (isLinkedMdaLocked.value) return
  // console.log('Sector changed to', sector.value)
  // fetchMdaDetails(mda.value)
  fetchMDAs(sector.value)
}

function onMdaChange() {
  if (isLinkedMdaLocked.value) return
  // console.log('MDA changed to', mda.value)
  const selected = mdas.value.find(item => item.id === mda.value)
  form.originatingMda = selected ? selected.name : ''
}

/**
 * Format any number with commas
 */
// function formatNumber(val) {
//   return Number(val || 0).toLocaleString();
// }

// /**
//  * Block keys other than digits, comma, or navigation
//  */
// function onlyDigitsAndComma(e) {
//   const k = e.key;
//   if (
//     (k >= '0' && k <= '9') ||
//     k === ',' || k === '.' ||
//     ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'].includes(k)
//   ) return;
//   e.preventDefault();
// }

// /**
//  * Handle the “Amount Approved” input:
//  * - strip non‑digits
//  * - update the numeric model
//  * - re‑format the visible field
//  */
// function onAmountApprovedInput(e) {
//   const digits = e.target.value.replace(/[^\d]/g, '');
//   form.amountApproved = digits === '' ? 0 : Number(digits);
//   e.target.value = formatNumber(form.amountApproved);
// }


function formatCurrency(val) {
  if (val === '' || val === null) return '';
  const num = parseFloat(val).toFixed(2);
  return Number(num).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/**
 * Handle Amount Approved input
 */
 const MAX_SAFE_RAW = Number.MAX_SAFE_INTEGER.toString(); // "9007199254740991"

function onAmountApprovedInput(e) {
  if (isLinkedPaymentVoucher.value) {
    e.target.value = formatCurrency(form.amountApproved)
    return
  }

  let raw = e.target.value.replace(/\D/g, '');

  if (raw === '') {
    form.amountApproved = '';
    e.target.value = '';
    return;
  }

  // Prevent adding more digits than safe
  if (raw.length > MAX_SAFE_RAW.length ||
      (raw.length === MAX_SAFE_RAW.length && raw > MAX_SAFE_RAW)) {
    raw = MAX_SAFE_RAW; // trim to safe max
  }

  const num = parseInt(raw, 10) / 100;
  form.amountApproved = Number(num.toFixed(2));
  e.target.value = formatCurrency(form.amountApproved);
}
function formatDisplayDate(val) {
  if (!val) return 'N/A'
  const date = new Date(val)
  if (Number.isNaN(date.getTime())) return String(val)
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  })
}
</script>

<style scoped>
.pv-preview-btn {
  background: #ffffff;
  color: #1f2937;
  border: 1px solid #d1d5db;
  font-weight: 600;
}

.pv-preview-btn:hover {
  background: #f3f4f6;
  color: #111827;
  border-color: #9ca3af;
}

.pv-preview-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  padding: 1rem;
}

.pv-preview-modal {
  background: #ffffff;
  width: min(1000px, 100%);
  max-height: 85vh;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.pv-preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.9rem 1rem;
  border-bottom: 1px solid #e5e7eb;
}

.pv-preview-body {
  padding: 1rem;
  overflow: auto;
}

.preview-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.75rem;
}

.preview-item {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 6px;
  padding: 0.6rem 0.75rem;
}

.preview-item small {
  display: block;
  color: #6b7280;
  font-size: 0.75rem;
  margin-bottom: 0.2rem;
}

.preview-item p {
  color: #111827;
  font-weight: 600;
  word-break: break-word;
}

.preview-item-wide {
  grid-column: span 3;
}

@media (max-width: 992px) {
  .preview-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .preview-item-wide {
    grid-column: span 2;
  }
}

@media (max-width: 576px) {
  .preview-grid {
    grid-template-columns: 1fr;
  }

  .preview-item-wide {
    grid-column: span 1;
  }
}

.view-only-input {
  border: none !important;
  background-color: transparent;
  padding-left: 0;
  cursor: default;
  pointer-events: none;
  color: #212529;
  font-size: 1rem;
  padding-right: 0;
  margin-right: 1rem;
  margin-bottom: 0.5rem !important;
}

.budget-item-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  /* forces every .col to match the tallest */
}

.budget-item-wrapper .view-only-input,
.budget-item-wrapper input.view-only-input {
  flex: 1;
  /* inputs (and your Approval‐Authority <div>) all grow equally */
  /* for your Approval Authority div: */
  white-space: pre-wrap;
}

.dashboard-layout .budget-item-wrapper {
  margin-top: 20px;
  padding: 0 40px;
}

.dashboard-layout .content-wrapper {
  border: 1px solid var(--border);
  background-color: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  padding: 1rem;
}

.dashboard-layout .section-border {
  /* padding: 1rem; */
  border-top: 3px solid #667eea !important;
}

.dashboard-layout .step-2 {
  padding: 0 20px;
}

.dashboard-layout .budget-item-wrapper.step-2 .col {
  border-right: 1px solid var(--border);
  /* box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05); */
}

.dashboard-layout .budget-item-wrapper.step-2 .col.no-border {
  border-right: none !important;
}

.dashboard-layout .budget-item-wrapper.step-3 .fixed-label {
  min-height: 80px;
  justify-content: flex-start;
  width: 350px;
  box-sizing: border-box;
  text-align: left;
  /* all: unset; */
  display: flex;
  margin-bottom: 0;
  flex-shrink: 0;
  margin-left: 1rem;
}

.dashboard-layout .budget-item-wrapper.step-3 .col {
  padding: 0;
}

.dashboard-layout .budget-item-wrapper.step-3 .content-wrapper {
  border: 1px solid var(--border);
  background-color: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  /* padding: 1rem; */
}

.dashboard-layout .budget-item-wrapper.step-3 .content {
  border-bottom: 2px solid var(--border);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  gap: 1rem;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}

.dashboard-layout .budget-item-wrapper.step-3 label {
  font-size: 16px;
  padding: .375rem 0 !important;
  margin-bottom: 0px !important;
  padding-bottom: 0.5rem;
  font-weight: 600;
}

.dashboard-layout .budget-item-wrapper .col-md-3 {
  border: 1px solid #212529;
}

.dashboard-layout .budget-item-wrapper .col-md-3.no-border {
  border: none;
}

.dashboard-layout .budget-item-wrapper .col-md-3.no-border label {
  padding: .375rem .75rem;
  margin-bottom: 0px !important;
}

.dashboard-layout .budget-item-wrapper .col-md-2.no-border {
  border: none;
}

.dashboard-layout .budget-item-wrapper .col-md-2.no-border label {
  padding: .375rem .75rem;
  margin-bottom: 0px !important;
}

.dashboard-layout .fixed-label {
  display: flex;
  align-items: center;
  /* vertical center */
  justify-content: center;
  /* horizontal center */
  min-height: 4rem;
  width: 100%;
  padding: 0 0.25rem;
  box-sizing: border-box;
  text-align: center;
}
</style>
